'use client';
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import { Bar, BarChart, CartesianGrid, Cell, Tooltip, TooltipProps } from 'recharts';

import { ArrowForwardIos } from '@mui/icons-material';
import TotalTransChart from '../../components/TotalTransChart';
import moment from 'moment';
import DateRange from '../../components/DateRangePicker';
import ExportButton from '../../components/ExportButton';
import { ResponsiveContainer, LineChart, XAxis, YAxis, Line } from 'recharts';
import { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#204e33' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));



interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
interface GraphHeaderProps {
  title: string;
  filter: string;
  setFilter: (value: string) => void;
  handleClick: (e: any) => void;
  getFormattedRange: () => void;
  range: { from?: Date; to?: Date };
  handleClearRange: () => void;
}

const GraphHeader: React.FC<GraphHeaderProps> = ({
  title,
  filter,
  setFilter,
  handleClick,
  getFormattedRange,
  range,
  handleClearRange,
}) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <h2 className="mn_hdng" style={{ margin: 0, padding: 0, borderBottom: 'none' }}>
        {title}
      </h2>

      <Box display="flex" gap={1} alignItems="center">
        <ExportButton onSelect={() => { }} borderRadius={'6px !important'} hideText />
        <FormControl size="small" sx={{ minWidth: 90 }}>
          <Select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <MenuItem value="Daily">Daily</MenuItem>
            <MenuItem value="Weekly">Weekly</MenuItem>
            <MenuItem value="Monthly">Monthly</MenuItem>
            <MenuItem value="Yearly">Yearly</MenuItem>
          </Select>
        </FormControl>
        <TextField
          variant="outlined"
          hiddenLabel
          className="text_field-range"
          onClick={handleClick}
          value={getFormattedRange()}
          placeholder="Select Date Range"
        />
        {range.from && range.to ? (
          <Typography variant="subtitle2" className="clear_flter" onClick={handleClearRange}>
            Clear
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const staticData = [
  { month: 'Jan', price: 1.2 },
  { month: 'Feb', price: 2.4 },
  { month: 'Mar', price: 1.8 },
  { month: 'Apr', price: 3.1 },
  { month: 'May', price: 2.9 },
  { month: 'June', price: 3.7 },
];

const CustomTooltip = ({ active, payload }: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length) {
    const price = payload[0].value as number;

    return (
      <div
        style={{
          background: '#fff',
          padding: '10px 14px',
          borderRadius: 9,
          boxShadow: '0px 4.57px 50.26px 0px #00000017',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span
            style={{
              display: 'inline-block',
              width: 8,
              height: 8,
              backgroundColor: '#0b807f',
              borderRadius: '50%',
            }}
          ></span>
          {/* <strong style={{ color: '#0b807f' }}>Price</strong> */}
          <span style={{ marginLeft: 4 }}>{Math.round(price)}</span>
        </div>
      </div>
    );
  }
  return null;
};
function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
interface DateRangeType {
  from: Date | undefined;
  to: Date | undefined;
}
const DashBoard: React.FC = () => {
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const filterOptions = ['Daily', 'Weekly', 'Monthly', 'Yearly'];

  const [revenueFilter, setRevenueFilter] = useState('Weekly');
  const [jobFilter, setJobFilter] = useState('Weekly');
  const [topRange, setTopRange] = useState<DateRangeType>({ from: undefined, to: undefined });
  const [topOpen, setTopOpen] = useState(false);
  const [topAnchorEl, setTopAnchorEl] = useState<HTMLElement | null>(null);
  const [topSelectedChip, setTopSelectedChip] = useState('');
  const [topMonth, setTopMonth] = useState(new Date());
  const titles = ['Customers', 'Service Providers'];

  // job analytics

  const [jobRange, setjobRange] = useState<DateRangeType>({ from: undefined, to: undefined });
  const [jobOpen, setJobOpen] = useState(false);
  const [jobAnchorEl, setJobAnchorEl] = useState<HTMLElement | null>(null);
  const [jobSelectedChip, setJobSelectedChip] = useState('');
  const [jobMonth, setJobMonth] = useState(new Date());

  // quick analytics
  const [quickRange, setQuickRange] = useState<DateRangeType>({ from: undefined, to: undefined });
  const [quickOpen, setQuickOpen] = useState(false);
  const [quickAnchorEl, setQuickAnchorEl] = useState<HTMLElement | null>(null);
  const [quickSelectedChip, setQuickSelectedChip] = useState('');
  const [quickMonth, setQuickMonth] = useState(new Date());

  const [filters, setFilters] = useState(Array(titles.length).fill('Daily'));

  const [open1, setOpen1] = useState(Array(titles.length).fill(false));
  const [anchorEl, setAnchorEl] = useState<(HTMLElement | null)[]>([]);
  const [selectedChip, setSelectedChip] = useState(Array(titles.length).fill(''));
  const [month, setMonth] = useState(Array(titles.length).fill(new Date()));
  const [ranges, setRanges] = useState(
    Array(titles.length).fill({ from: undefined, to: undefined }),
  );

  const handleFilterChange = (index: number, value: any) => {
    const newFilters = [...filters];
    newFilters[index] = value;
    setFilters(newFilters);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
    const newAnchorEl = [...anchorEl];
    newAnchorEl[index] = event.currentTarget;
    setAnchorEl(newAnchorEl);

    const newOpen = [...open1];
    newOpen[index] = true;
    setOpen1(newOpen);
  };

  const getFormattedRange = (index: number) => {
    const range = ranges[index];
    if (range?.from && range?.to) {
      return `${moment(range.from).format('MM/DD/YYYY')} - ${moment(range.to).format('MM/DD/YYYY')}`;
    } else if (range?.from) {
      return moment(range.from).format('MM/DD/YYYY');
    }
    return '';
  };

  const getTopFormattedRange = () => {
    if (topRange?.from && topRange?.to) {
      return `${moment(topRange.from).format('MM/DD/YYYY')} - ${moment(topRange.to).format(
        'MM/DD/YYYY',
      )}`;
    } else if (topRange?.from) {
      return moment(topRange.from).format('MM/DD/YYYY');
    }
    return '';
  };

  const getJobFormattedRange = () => {
    if (jobRange?.from && jobRange?.to) {
      return `${moment(jobRange.from).format('MM/DD/YYYY')} - ${moment(jobRange.to).format(
        'MM/DD/YYYY',
      )}`;
    } else if (jobRange?.from) {
      return moment(jobRange.from).format('MM/DD/YYYY');
    }
    return '';
  };

  const getQuickFormattedRange = () => {
    if (quickRange?.from && quickRange?.to) {
      return `${moment(quickRange.from).format('MM/DD/YYYY')} - ${moment(quickRange.to).format(
        'MM/DD/YYYY',
      )}`;
    } else if (quickRange?.from) {
      return moment(quickRange.from).format('MM/DD/YYYY');
    }
    return '';
  };
  const [stats] = useState({
    totalJobSeekers: 1250,
    totalEmployers: 320,
    activeJobs: 180,
    premiumSubscribers: 97,
    revenue: 14200,
    pendingApprovals: 12,
    fraudReports: 4,
  });


  const handleTopClick = (event: React.MouseEvent<HTMLElement>) => {
    setTopAnchorEl(event.currentTarget);
    setTopOpen(true);
  };

  const handleJobClick = (event: React.MouseEvent<HTMLElement>) => {
    setJobAnchorEl(event.currentTarget);
    setJobOpen(true);
  };

  const handleQuickClick = (event: React.MouseEvent<HTMLElement>) => {
    setQuickAnchorEl(event.currentTarget);
    setQuickOpen(true);
  };

  const handleClearTopRange = () => {
    setTopRange({ from: undefined, to: undefined });
    setTopSelectedChip('');
    setTopMonth(new Date());
  };
  const handleClearQuickRange = () => {
    setQuickRange({ from: undefined, to: undefined });
    setQuickSelectedChip('');
    setQuickMonth(new Date());
  };
  const handleClearJobRange = () => {
    setjobRange({ from: undefined, to: undefined });
    setJobSelectedChip('');
    setJobMonth(new Date());
  };

  const handleClearRange = (index: number) => {
    const updatedRanges = [...ranges];
    updatedRanges[index] = { from: undefined, to: undefined };
    setRanges(updatedRanges);
  };
  const data = staticData;

  const isEmptyOrZeroData = (data: { price: number }[]) => {
    return !data?.length || data?.every((item) => item.price === 0);
  };

  
const COLORS = ["#0088FE", "#FF8042", "#FF6384", "#4BC0C0", "#00C49F"];

// Chart Data
const totalCustomers = [
  { name: "Mon", count: 50 },
  { name: "Tue", count: 65 },
  { name: "Wed", count: 80 },
  { name: "Thu", count: 70 },
  { name: "Fri", count: 90 },
  { name: "Sat", count: 120 },
  { name: "Sun", count: 110 },
];

const totalProviders = [
  { name: "Mon", count: 10 },
  { name: "Tue", count: 12 },
  { name: "Wed", count: 15 },
  { name: "Thu", count: 14 },
  { name: "Fri", count: 18 },
  { name: "Sat", count: 20 },
  { name: "Sun", count: 22 },
];

// const totalBookings = [
//   { name: "Mon", count: 25 },
//   { name: "Tue", count: 30 },
//   { name: "Wed", count: 28 },
//   { name: "Thu", count: 35 },
//   { name: "Fri", count: 40 },
//   { name: "Sat", count: 50 },
//   { name: "Sun", count: 45 },
// ];


  const chartData = isEmptyOrZeroData(data) ? staticData : data;
  return (
    <div className="main_loyout">
      <div className="dashboard">
        <h1 className="mn_hdng"> Dashboard</h1>
        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          {topRange.from && topRange.to ? (
            <Typography
              variant="subtitle2"
              className="clear_flter"
              onClick={handleClearTopRange}
              sx={{ cursor: 'pointer' }}
            >
              Clear
            </Typography>
          ) : null}
          <TextField
            variant="outlined"
            hiddenLabel
            className="text_field-range"
            onClick={handleTopClick}
            value={getTopFormattedRange()}
            placeholder="Select Date Range"
          />
        </Box>
        <DateRange
          anchorEl={topAnchorEl}
          open={topOpen}
          setOpen={setTopOpen}
          setAnchorEl={setTopAnchorEl}
          range={topRange}
          setRange={setTopRange}
          selectedChip={topSelectedChip}
          setSelectedChip={setTopSelectedChip}
          month={topMonth}
          setMonth={setTopMonth}
        />
      </div>
      <div className="gap_m dash_grid">
        <div className="lt">
          <div className="white_card ttl_p_wrap p_20">
            <div className="ttl_p">
              <figure>
                <img src="/static/images/booking.svg" alt="icon" />
              </figure>
              <div className="ttl_p_cnt">
                <h3>200</h3>
                <p>Total Bookings</p>
              </div>
            </div>
            <ul className="sale_list">
              <li>
                <h4>100</h4>
                <p>Active </p>
              </li>
              <li>
                <h4>100</h4>
                <p>New</p>
              </li>
            </ul>
          </div>
          <div className="white_card ttl_p_wrap p_20" style={{ marginTop: '10px' }}>
            <div className="ttl_p">
              <figure>
                <img src={'/static/images/provider.svg'} alt="icon" />
              </figure>
              <div className="ttl_p_cnt">
                <h3>100</h3>
                <p>Total Service Providers</p>
              </div>
            </div>
            <ul className="sale_list">
              <li>
                <h4>50</h4>
                <p>Freelancers</p>  
              </li>
              <li>
                <h4>50</h4>
                <p>Salon</p>
              </li>
            </ul>
          </div>
          <div className="white_card analytic_card p_20 mt_20">
            <div className="white_card_head2">
              <h3>Quick Analytics</h3>
              <Box display="flex" gap={2} alignItems="center">
                {quickRange.from || quickRange.to ? (
                  <Typography
                    variant="subtitle2"
                    className="clear_flter"
                    onClick={handleClearQuickRange}
                    sx={{ cursor: 'pointer' }}
                  >
                    Clear
                  </Typography>
                ) : null}
                <TextField
                  variant="outlined"
                  hiddenLabel
                  className="text_field-range"
                  onClick={handleQuickClick}
                  value={getQuickFormattedRange()}
                  placeholder="Select Date Range"
                />
                <DateRange
                  anchorEl={quickAnchorEl}
                  open={quickOpen}
                  setOpen={setQuickOpen}
                  setAnchorEl={setQuickAnchorEl}
                  range={quickRange}
                  setRange={setQuickRange}
                  selectedChip={quickSelectedChip}
                  setSelectedChip={setQuickSelectedChip}
                  month={quickMonth}
                  setMonth={setQuickMonth}
                />
                <FormControl size="small" sx={{ minWidth: 120 }}>
                  <Select value={revenueFilter} onChange={(e) => setRevenueFilter(e.target.value)}>
                    {filterOptions.map((opt) => (
                      <MenuItem value={opt} key={opt}>
                        {opt}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <ExportButton onSelect={() => { }} borderRadius={'6px !important'} hideText />
              </Box>
            </div>
            <div className="verticle_tabs">
              <Tabs
                variant="scrollable"
                onChange={handleChange}
                value={value}
                aria-label="Vertical tabs example"
                className="tabs4"
              >
                <Tab
                  disableRipple
                  label={
                    <div className="tab_header">
                      <span className="arrow_icon">
                        {' '}
                        <ArrowForwardIos />
                      </span>
                      <span>Total Revenue</span>
                      <h3>AED 27.30 M</h3>
                      <div className="tag"> + 18,6% from last month</div>{' '}
                    </div>
                  }
                  {...a11yProps(0)}
                />
                <Tab
                  disableRipple
                  label={
                    <div className="tab_header">
                      <span className="arrow_icon">
                        {' '}
                        <ArrowForwardIos />
                      </span>

                      <span>Earning From Salon</span>
                      <h3>AED 54,00 K</h3>
                      <div className="tag"> - 14% from last month</div>
                    </div>
                  }
                  {...a11yProps(1)}
                />
                <Tab
                  disableRipple
                  label={
                    <div className="tab_header">
                      <span className="arrow_icon">
                        <ArrowForwardIos />
                      </span>
                      <span>Earning From Freelancers </span>
                      <h3>AED 5400</h3>
                      <div className="tag"> -14% From Last Month</div>
                    </div>
                  }
                  {...a11yProps(2)}
                />
              </Tabs>
              <div className="tab_content">
                <TabPanel value={value} index={0}>
                  <div className="lineChart" style={{ width: '100%', height: 300 }}>
                    <ResponsiveContainer>
                      <LineChart data={chartData}>
                        <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                        <YAxis
                          tickFormatter={(value) => `${value}`}
                          domain={[0, 'auto']}
                          tick={{ fontSize: 12 }}
                          allowDecimals={false}
                        />
                        <Tooltip content={() => <CustomTooltip />} />
                        <Line
                          type="monotone"
                          dataKey="price"
                          stroke="#0b807f"
                          strokeWidth={3}
                          dot={{ stroke: '#fff', strokeWidth: 2, r: 5, fill: '#0b807f' }}
                          activeDot={{ r: 6 }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <div className="lineChart" style={{ width: '100%', height: 300 }}>
                    <ResponsiveContainer>
                      <LineChart data={chartData}>
                        <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                        <YAxis
                          tickFormatter={(value) => `${value}`}
                          domain={[0, 'auto']}
                          tick={{ fontSize: 12 }}
                          allowDecimals={false}
                        />
                        <Tooltip content={() => <CustomTooltip />} />
                        <Line
                          type="monotone"
                          dataKey="price"
                          stroke="#0b807f"
                          strokeWidth={3}
                          dot={{ stroke: '#fff', strokeWidth: 2, r: 5, fill: '#0b807f' }}
                          activeDot={{ r: 6 }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <div className="lineChart" style={{ width: '100%', height: 300 }}>
                    <ResponsiveContainer>
                      <LineChart data={chartData}>
                        <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                        <YAxis
                          tickFormatter={(value) => `${value}`}
                          domain={[0, 'auto']}
                          tick={{ fontSize: 12 }}
                          allowDecimals={false}
                        />
                        <Tooltip content={() => <CustomTooltip />} />
                        <Line
                          type="monotone"
                          dataKey="price"
                          stroke="#0b807f"
                          strokeWidth={3}
                          dot={{ stroke: '#fff', strokeWidth: 2, r: 5, fill: '#0b807f' }}
                          activeDot={{ r: 6 }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </TabPanel>
              </div>  
            </div>
          </div>
        </div>
        <div className="rt">
          <div className="white_card p_20">
            <div className="white_card_head2 flex" style={{ marginBottom: 0, gap: '30px' }}>
              <h2>Booking Analytics</h2>
              <Box display="flex" gap={2} alignItems="center">
                <ExportButton onSelect={() => { }} borderRadius={'6px !important'} />
              </Box>
            </div>
            <div className="white_card_head2" style={{ marginTop: '10px' }}>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <Select value={jobFilter} onChange={(e) => setJobFilter(e.target.value)}>
                  {filterOptions.map((opt) => (
                    <MenuItem value={opt} key={opt}>
                      {opt}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                variant="outlined"
                hiddenLabel
                className="text_field-range"
                onClick={handleJobClick}
                value={getJobFormattedRange()}
                placeholder="Select Date Range"
              />
              {jobRange.from || jobRange.to ? (
                <Typography
                  variant="subtitle2"
                  className="clear_flter"
                  onClick={handleClearJobRange}
                  sx={{ cursor: 'pointer' }}
                >
                  Clear
                </Typography>
              ) : null}
              <DateRange
                anchorEl={jobAnchorEl}
                open={jobOpen}
                setOpen={setJobOpen}
                setAnchorEl={setJobAnchorEl}
                range={jobRange}
                setRange={setjobRange}
                selectedChip={jobSelectedChip}
                setSelectedChip={setJobSelectedChip}
                month={jobMonth}
                setMonth={setJobMonth}
              />
            </div>
            <TotalTransChart />
            {/* <div className="white_card_head2 flex" style={{ marginBottom: 0, marginTop: '16px' }}>
              <h2>Other</h2>
            </div>
            <ul className="total_trrans">
              <li style={{ '--c_marker': '#050a34' } as React.CSSProperties}>
                <p>Active communities</p>
                <h4>10</h4>
              </li>
              <li style={{ '--c_marker': '#050a34' } as React.CSSProperties}>
                <p>Reports/flags count</p>
                <h4>2</h4>
              </li>
            </ul> */}
          </div>
        </div>
      </div>

      <Grid container spacing={2} className="dashGraph" sx={{ pt: 4 }}>
        {titles.map((title, index) => (
          <Grid item lg={6} md={6} sm={12} xs={12} key={index}>
            <Item className="cards dashGraph_item">
              <GraphHeader
                title={title}
                filter={filters[index]}
                setFilter={(value) => handleFilterChange(index, value)}
                handleClick={(e) => handleClick(e, index)}
                getFormattedRange={() => getFormattedRange(index)}
                range={ranges[index]}
                handleClearRange={() => handleClearRange(index)}
              />
           
              <div className="lineChart" style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <LineChart data={chartData}>
                    <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                    <YAxis
                      tickFormatter={(value) => `${value}`}
                      domain={[0, 'auto']}
                      tick={{ fontSize: 12 }}
                      allowDecimals={false}
                    />
                    <Tooltip content={() => <CustomTooltip />} />
                    <Line
                      type="monotone"
                      dataKey="price"
                      stroke="#0b807f"
                      strokeWidth={3}
                      dot={{ stroke: '#fff', strokeWidth: 2, r: 5, fill: '#0b807f' }}
                      activeDot={{ r: 6 }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>

            </Item>
          </Grid>
        ))}
      </Grid>
                  <div className="grid_sc pt_0 gap_m">
                      {/* 1. Total Customers */}
                      <div className="cards table_card">
                        <div className="cards_header">
                          <div className="left_s">
                            <h2>Total Bookings</h2>
                          </div>
                          <div className="right_s">
                            <p>
                              <span>A day</span>
                              <span>A week</span>
                              <span>A month</span>
                              <span>A year</span>
                            </p>
                          </div>
                        </div>
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={totalCustomers}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="count" fill="#0088FE" />
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
              
                      {/* 2. Total Service Providers */}
                      <div className="cards table_card">
                        <div className="cards_header">
                          <div className="left_s">
                            <h2>Total Revenue</h2>
                          </div>
                          <div className="right_s">
                            <p>
                              <span>A day</span>
                              <span>A week</span>
                              <span>A month</span>
                              <span>A year</span>
                            </p>
                          </div>
                        </div>
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={totalProviders}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="count" fill="#4BC0C0" />
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
              
                      {/* 3. Total Bookings
                      <div className="cards table_card">
                        <div className="cards_header">
                          <div className="left_s">
                            <h2>Total Bookings</h2>
                          </div>
                          <div className="right_s">
                            <p>
                              <span>A day</span>
                              <span>A week</span>
                              <span>A month</span>
                              <span>A year</span>
                            </p>
                          </div>
                        </div>
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={totalBookings}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="count">
                              {totalBookings.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div> */}
                  </div>
    </div>
  );
};

export default DashBoard;
